import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { Platform } from "react-native";
import { GlobalThisABTestClient } from "../../domain/globalThisABTestClient/GlobalThisABTestClient";
import { queryClientContext } from "../hooks/useQueryClient";
import { useStaticInfo } from "../hooks/useStaticInfo";
import { OS } from "../shared/config";

const globalThisABTestClient = new GlobalThisABTestClient();

const useGetExperiments = () => {
  const {
    session: { auth },
  } = useStaticInfo();

  const queryClient = useContext(queryClientContext);

  const { isLoading, data } = useQuery(
    {
      queryKey: ["getExperiments"],
      queryFn: async () => {
        if (Platform.OS !== OS.WEB) {
          return undefined;
        }

        return await globalThisABTestClient.getExperiments();
      },
      enabled: Boolean(auth),
    },
    queryClient,
  );

  return { experiments: data, isLoading };
};

export { useGetExperiments };
